import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { ResourcesPage } from 'src/pages/resources';
import { ExternalHelpRedirect } from 'src/pages/resources/ExternalHelpRedirect';
import { RouteProps } from 'src/types/router';

import { ResourcesOutlet } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <ResourcesPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.resources.helpLegacyIndex,
    element: <ExternalHelpRedirect />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.resources.helpLegacy,
    element: <ExternalHelpRedirect />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.resources.notionLegacy,
    element: <ExternalHelpRedirect />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const RESOURCES_ROUTE: RouteProps = {
  path: appRoutes.resources.index,
  element: <ResourcesOutlet />,
  childRoutes: ROUTES,
  accessRoles: [
    ReactRouteAccessKey.isEmployee,
    ReactRouteAccessKey.hasEmployerRoles,
    ReactRouteAccessKey.hasVerifierRoles,
    ReactRouteAccessKey.hasPeoRoles,
    ReactRouteAccessKey.isPeoPayrollProviderUser,
  ],
};
